<template>
    <div class="tab-container">
        <div class="tab-header">
            <div class="tab-buttons">
                <button
                    v-for="(tab, index) in tabs"
                    :key="index"
                    type="button"
                    class="tab-button"
                    :class="{ active: activeTab === getTabValue(tab, index) }"
                    @click="handleTabClick(tab, index)"
                >
                    {{ getTabLabel(tab) }}
                </button>
            </div>
            <div class="tab-actions">
                <slot name="actions" :activeTab="activeTab" />
            </div>
        </div>
        <div class="tab-content">
            <slot :activeTab="activeTab" />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        tabs: {
            type: Array,
            required: true,
            validator(value) {
                // tabs는 문자열 배열이거나 { label, value } 객체 배열
                return (
                    Array.isArray(value) &&
                    value.every(
                        (tab) =>
                            typeof tab === "string" ||
                            (typeof tab === "object" && tab !== null && (tab.label || tab.value))
                    )
                );
            },
        },
        activeTab: {
            type: [String, Number],
            required: true,
        },
    },
    emits: ["update:activeTab", "tab-change"],
    methods: {
        getTabLabel(tab) {
            if (typeof tab === "string") {
                return tab;
            }
            return tab.label || tab.value || "";
        },
        getTabValue(tab, index) {
            if (typeof tab === "string") {
                return tab;
            }
            return tab.value !== undefined ? tab.value : index;
        },
        handleTabClick(tab, index) {
            const newValue = this.getTabValue(tab, index);
            this.$emit("update:activeTab", newValue);
            this.$emit("tab-change", newValue, tab, index);
        },
    },
};
</script>

<style scoped>
.tab-container {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    min-width: 0;
}

.tab-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    padding: 10px 0px;
    width: 100%;
}

.tab-buttons {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
}

.tab-actions {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
    flex: 1 1 auto;
    justify-content: flex-end;
    min-width: 200px;
    max-width: 100%;
    overflow: visible;
}

.tab-actions:empty {
    display: none;
}

.tab-button {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 8px 14px;
    font-size: 12px;
    font-weight: 600;
    color: #6b7280;
    border: 1px solid transparent;
    border-radius: 8px;
    background: transparent;
    cursor: pointer;
    transition: all 0.12s ease;
}

.tab-button:hover {
    color: #111827;
    background: #f3f4f6;
}

.tab-button.active {
    color: #ffffff;
    background: #52b788;
    box-shadow: 0 4px 10px rgba(15, 23, 42, 0.08);
}

.tab-content {
    flex: 1;
    min-height: 0;
}

@media (max-width: 768px) {
    .tab-header {
        flex-direction: column;
        align-items: stretch;
    }

    .tab-buttons {
        width: 100%;
    }

    .tab-button {
        flex: 1;
        justify-content: center;
    }

    .tab-actions {
        width: 100%;
        flex-wrap: wrap;
    }
}
</style>